import { Endpoint } from '~/features/webhooks/types';
import { SuspendApiResponse } from '~/redux/api/types/courier/endpoints';
import { courier } from '~/services/serviceInstances';

interface Request {
  endpoint: Endpoint;
}

export const suspendEndpoint = async ({
  endpoint,
}: Request): Promise<boolean> => {
  const response: SuspendApiResponse = await courier.patch(
    `/endpoints/${endpoint.id}/suspend`,
  );

  return Boolean(response);
};
